import React, { useCallback } from 'react'
import { useDrawer } from 'ducks/drawers/hooks'
import { DRAWER_TYPE_SHOPIFY_CREATE_ORDER } from 'ducks/drawers/types'
import { Button } from 'util/ui'
import { buildDrawerQueryParam } from 'ducks/drawers/util'

const CreateOrderButton = ({ integration, customerGid, ...props }) => {
  const { drawerId, openDrawer } = useDrawer({
    type: DRAWER_TYPE_SHOPIFY_CREATE_ORDER,
  })

  const onOpen = useCallback(
    () => {
      openDrawer(customerGid, {
        query: {
          ...buildDrawerQueryParam(
            drawerId,
            'drawerIntegrationId',
            integration.id
          ),
        },
        additionalProps: {
          drawerIntegrationId: integration.id,
          ...props,
        },
      })
    },
    [openDrawer, drawerId, props, integration, customerGid]
  )

  return (
    <Button basic onClick={onOpen}>
      Create order
    </Button>
  )
}

export default CreateOrderButton
